import { render, staticRenderFns } from "./LtcatModal.vue?vue&type=template&id=38a56351&"
import script from "./LtcatModal.vue?vue&type=script&lang=js&"
export * from "./LtcatModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports